/* -------------------------------------------------------------------------------------------------
 * props
 * -----------------------------------------------------------------------------------------------*/

type SvgComponentProps = {
  width?: number
  height?: number
}

/* -------------------------------------------------------------------------------------------------
 * component
 * -----------------------------------------------------------------------------------------------*/

const SvgComponent = ({ height = 50, width = 50 }: SvgComponentProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 50 50"
    fill="none"
  >
    <rect width={50} height={50} className="fill-(--success-circle)" rx={25} />
    <path
      className="stroke-(--success-circle-mark)"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M37.031 17.344 21.72 32.656l-7.656-7.655"
    />
  </svg>
)
export { SvgComponent as SuccessCircle }
